// Docs.js
import React, { useState, useRef, useEffect } from 'react';
import '../style/docs.css';

function Docs({ title, desc, id, onChange, name, file, error }) {
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState("");
    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            setFileName(file.name);
            onChange(name, file)
        }
    };

    useEffect(() => {
        if (typeof file === "string") {
            setSelectedFile(file);
            setFileName(file);
        } else {
            setSelectedFile(file);
            setFileName(file.name);
        }
    }, [])

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    return (
        <>
            <div className="docs-row">
                <div className="Document_Name">
                    <h4 id={id}>{title}</h4>
                    <p>{desc}</p>
                </div>
                <div className="Uploaded-file-name">
                    <input
                        type="file"
                        accept=".pdf, .png, .jpg"
                        id={`${id}_filename`}
                        onChange={handleFileChange}
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                    />
                    <p>{fileName ? fileName : "No file selected"}</p>
                    <button type="button" onClick={triggerFileInput}>
                        {fileName ? 'Change File' : 'Choose File'}
                    </button>
                </div>
            </div>
            <div className="error-msg-row">
                {error && <p className="error-message">{error}</p>}
            </div>
        </>
    );
}

export default Docs;